import { InvoiceOutgoing, InvoiceOutgoingEditFormValues, InvoiceOutgoingItemChildRow, InvoiceOutgoingItemEditFormValues, InvoiceOutgoingItemRow, InvoiceOutgoingRow, InvoiceRent, InvoiceRentEditFormValues, InvoiceRentRow, InvoiceStatus } from "./types";


export const transformFleetVehicleInvoiceRow = (
  res: any
): InvoiceOutgoingRow => {

  return {
    id: res.id,
    invoiceNumber: res.invoiceNumber,
    contractNumber: res.contractNumber ?? null,
    offerNumber: res.offerNumber ?? null,
    contract: res.contract ?? null,
    offer: res.offer ?? null,
    status: res.status ? transformInvoiceStatus(res.status) : null,
    vehicle: res.vehicle,
    contactClient: res.contactClient,
    invoiceDate: res.invoiceDate,
    dueDate: res.dueDate,
    durationDays: res.durationDays,
    taxRate: res.taxRate,
    taxTypeId: res.taxTypeId ?? null,
    taxExemptionReasonId: res.taxExemptionReasonId ?? null,
    total: res.total,
    buyerType: res.buyerType ?? null,
    fiscalizationStatus: res.fiscalizationStatus ?? null,
    userCreatedName: res.userCreatedName ?? null,
    pdfUpload: res.pdfUpload ?? null,
  };
};


export const transformFleetVehicleInvoice = (
  res: any
): InvoiceOutgoing => ({
  id: res.id,
  invoiceNumber: res.invoiceNumber,
  contractSaleId: res.contractSaleId ?? null,
  contractRentId: res.contractRentId ?? null,
  status: transformInvoiceStatus(res.status),
  statusHistory: res.statusHistory ?? [],
  vehicle: res.vehicle,
  contactClient: res.contactClient,
  invoiceDate: res.invoiceDate,
  dueDate: res.dueDate,
  durationDays: res.durationDays,
  taxRate: res.taxRate,
  taxTypeId: res.taxTypeId ?? null,
  taxExemptionReasonId: res.taxExemptionReasonId ?? null,
  total: res.total,
  items: res.items,
  buyerTypeId: res.buyerTypeId ?? null,
  buyerType: res.buyerType ?? null,
  paymentMethodId: res.paymentMethodId ?? null,
  paymentMethod: res.paymentMethod ?? null,
  paymentIBAN: res.paymentIBAN ?? null,
  deliveryDate: res.deliveryDate ?? null,
  buyerName: res.buyerName ?? null,
  buyerAddress: res.buyerAddress ?? null,
  buyerOIB: res.buyerOIB ?? null,
  buyerVAT: res.buyerVAT ?? null,
  buyerCountryId: res.buyerCountryId ?? null,
  note: res.note ?? null,
  internalNote: res.internalNote ?? null,
  currencyId: res.currencyId ?? null,
  exchangeRate: res.exchangeRate ?? null,
  languageId: res.languageId ?? null,
  fiscalizationRequired: res.fiscalizationRequired ?? false,
  fiscalizationVersion: res.fiscalizationVersion ?? null,
  fiscalizationStatus: res.fiscalizationStatus ?? null,
  fiscalizationJIR: res.fiscalizationJIR ?? null,
  fiscalizationZKI: res.fiscalizationZKI ?? null,
  fiscalizationErrorMessage: res.fiscalizationErrorMessage ?? null,
  providerExternalId: res.providerExternalId ?? null,
  emailSentAt: res.emailSentAt ?? null,
  emailSentTo: res.emailSentTo ?? null,
  pdfUpload: res.pdfUpload ?? null,
});




export const transformFleetVehicleInvoiceEditForm = (
  res: InvoiceOutgoing
): InvoiceOutgoingEditFormValues => ({
  id: res.id,
  invoiceNumber: res.invoiceNumber ?? null,
  contractSaleId: res.contractSaleId ?? null,
  contractRentId: res.contractRentId ?? null,
  invoiceStatusId: res.status?.id ?? null,
  vehicleId: res.vehicle?.id ?? null,
  contactClientId: res.contactClient?.id ?? null,
  invoiceDate: res.invoiceDate,
  dueDate: res.dueDate,
  durationDays: res.durationDays,
  taxRate: res.taxRate,
  taxTypeId: res.taxTypeId ?? null,
  taxExemptionReasonId: res.taxExemptionReasonId ?? null,
  items: res.items,
  buyerTypeId: res.buyerTypeId ?? null,
  paymentMethodId: res.paymentMethodId ?? null,
  paymentIBAN: res.paymentIBAN ?? null,
  deliveryDate: res.deliveryDate ?? null,
  buyerName: res.buyerName ?? null,
  buyerAddress: res.buyerAddress ?? null,
  buyerOIB: res.buyerOIB ?? null,
  buyerVAT: res.buyerVAT ?? null,
  buyerCountryId: res.buyerCountryId ?? null,
  note: res.note ?? null,
  internalNote: res.internalNote ?? null,
  currencyId: res.currencyId ?? null,
  exchangeRate: res.exchangeRate ?? null,
  languageId: res.languageId ?? null,
  fiscalizationRequired: res.fiscalizationRequired ?? false,
  fiscalizationVersion: res.fiscalizationVersion ?? null,
  fiscalizationStatus: res.fiscalizationStatus ?? null,
  fiscalizationJIR: res.fiscalizationJIR ?? null,
  fiscalizationZKI: res.fiscalizationZKI ?? null,
  fiscalizationErrorMessage: res.fiscalizationErrorMessage ?? null,
  providerExternalId: res.providerExternalId ?? null,
  emailSentAt: res.emailSentAt ?? null,
  emailSentTo: res.emailSentTo ?? null,
});


export const transformFleetVehicleInvoiceOnCreate = (
  formValues: InvoiceOutgoingEditFormValues
): any => ({
  invoiceNumber: formValues.invoiceNumber,
  contractSaleId: formValues.contractSaleId,
  contractRentId: formValues.contractRentId,
  invoiceStatusId: formValues.invoiceStatusId,
  contactClientId: formValues.contactClientId,
  invoiceDate: formValues.invoiceDate,
  dueDate: formValues.dueDate,
  durationDays: formValues.durationDays,
  taxRate: formValues.taxRate,
  taxTypeId: formValues.taxTypeId,
  taxExemptionReasonId: formValues.taxExemptionReasonId,
  items: formValues.items,
  buyerTypeId: formValues.buyerTypeId,

  paymentMethodId: formValues.paymentMethodId,
  paymentIBAN: formValues.paymentIBAN,
  deliveryDate: formValues.deliveryDate,
  buyerName: formValues.buyerName,
  buyerAddress: formValues.buyerAddress,
  buyerOIB: formValues.buyerOIB,
  buyerVAT: formValues.buyerVAT,
  buyerCountryId: formValues.buyerCountryId,
  note: formValues.note,
  internalNote: formValues.internalNote,
  currencyId: formValues.currencyId,
  exchangeRate: formValues.exchangeRate,
  languageId: formValues.languageId,
});

export const transformFleetVehicleInvoiceOnUpdate = (
  invoiceId: string,
  formValues: InvoiceOutgoingEditFormValues,
): any => ({
  id: invoiceId,
  contractSaleId: formValues.contractSaleId,
  contractRentId: formValues.contractRentId,
  invoiceStatusId: formValues.invoiceStatusId,
  vehicleId: formValues.vehicleId,
  contactClientId: formValues.contactClientId,
  invoiceDate: formValues.invoiceDate,
  dueDate: formValues.dueDate,
  durationDays: formValues.durationDays,
  taxRate: formValues.taxRate,
  taxTypeId: formValues.taxTypeId,
  taxExemptionReasonId: formValues.taxExemptionReasonId,
  items: formValues.items,
  buyerTypeId: formValues.buyerTypeId,

  paymentMethodId: formValues.paymentMethodId,
  paymentIBAN: formValues.paymentIBAN,
  deliveryDate: formValues.deliveryDate,
  buyerName: formValues.buyerName,
  buyerAddress: formValues.buyerAddress,
  buyerOIB: formValues.buyerOIB,
  buyerVAT: formValues.buyerVAT,
  buyerCountryId: formValues.buyerCountryId,
  note: formValues.note,
  internalNote: formValues.internalNote,
  currencyId: formValues.currencyId,
  exchangeRate: formValues.exchangeRate,
  languageId: formValues.languageId,
});



export const transformInvoiceItemRow = (
  res: InvoiceOutgoingItemEditFormValues
): InvoiceOutgoingItemRow => {
  return {
    id: res.id ? res.id : crypto.randomUUID(),
    code: res.code,
    name: res.name,
    taxRate: res.taxRate,
    quantity: res.quantity,
    priceWithoutTax: res.priceWithoutTax,
    priceWithTax: res.priceWithTax,
    discountAmount: res.discountAmount,
    discountTypeId: res.discountTypeId,
    total: res.total,
    deleted: false,
    kpdCode: res.kpdCode,
    unitOfMeasureId: res.unitOfMeasureId,
    discountPercent: res.discountPercent,
    billingItemTypeId: res.billingItemTypeId,
    billingItemTypeName: res.billingItemTypeName ?? null,
    note: res.note,
    childRows: res.note
      ? [transformInvoiceItemChildRow(res)]
      : [],
  };
};

export const transformInvoiceItemChildRow = (
  res: InvoiceOutgoingItemEditFormValues
): InvoiceOutgoingItemChildRow => {
  return {
    note: res.note,
  };
};


export const transformInvoiceItemRowToForm = (
  row: InvoiceOutgoingItemRow
): InvoiceOutgoingItemEditFormValues => {
  return {
    id: row.id,
    code: row.code,
    name: row.name,
    taxRate: row.taxRate,
    quantity: row.quantity,
    priceWithoutTax: row.priceWithoutTax,
    priceWithTax: row.priceWithTax,
    discountAmount: row.discountAmount,
    discountTypeId: row.discountTypeId,
    total: row.total,
    note: row.note ?? row.childRows?.[0]?.note ?? null,
    kpdCode: row.kpdCode,
    unitOfMeasureId: row.unitOfMeasureId,
    discountPercent: row.discountPercent,
    billingItemTypeId: row.billingItemTypeId,
    billingItemTypeName: row.billingItemTypeName ?? null,
  };
};

export const transformInvoiceStatus = (res: any): InvoiceStatus => ({
  id: res.id,
  name: res.name,
  color: res.color,
});

/*---------------------------------------------------------------
    INVOICE RENT TRANSFORMATIONS
  ---------------------------------------------------------------*/

export const transformFleetVehicleInvoiceRentRow = (
  res: any
): InvoiceRentRow => {
  return {
    id: res.id,
    invoiceNumber: res.invoiceNumber,
    contractNumber: res.contractNumber ?? null,
    offerNumber: res.offerNumber ?? null,
    contract: res.contract ?? null,
    offer: res.offer ?? null,
    invoiceOutgoingTypeId: res.invoiceOutgoingTypeId ?? null,
    status: res.status ? transformInvoiceStatus(res.status) : null,
    vehicle: res.vehicle,
    contactClient: res.contactClient,
    invoiceDate: res.invoiceDate,
    dueDate: res.dueDate,
    durationDays: res.durationDays,
    taxRate: res.taxRate,
    taxTypeId: res.taxTypeId ?? null,
    taxExemptionReasonId: res.taxExemptionReasonId ?? null,
    total: res.total,
    buyerType: null,
    fiscalizationStatus: res.fiscalizationStatus ?? null,
    userCreatedName: res.userCreatedName ?? null,
    pdfUpload: res.pdfUpload ?? null,
  };
};

export const transformFleetVehicleInvoiceRent = (
  res: any
): InvoiceRent => ({
  id: res.id,
  invoiceNumber: res.invoiceNumber,
  invoiceOutgoingTypeId: res.invoiceOutgoingTypeId ?? null,
  contractRentId: res.contractRentId ?? null,
  status: transformInvoiceStatus(res.status),
  statusHistory: res.statusHistory ?? [],
  vehicle: res.vehicle,
  contactClient: res.contactClient,
  invoiceDate: res.invoiceDate,
  dueDate: res.dueDate,
  durationDays: res.durationDays,
  taxRate: res.taxRate,
  taxTypeId: res.taxTypeId ?? null,
  taxExemptionReasonId: res.taxExemptionReasonId ?? null,
  total: res.total,
  items: res.items,
  paymentMethodId: res.paymentMethodId ?? null,
  paymentMethod: res.paymentMethod ?? null,
  paymentIBAN: res.paymentIBAN ?? null,
  deliveryDate: res.deliveryDate ?? null,
  renterName: res.renterName ?? null,
  renterAddress: res.renterAddress ?? null,
  renterOIB: res.renterOIB ?? null,
  renterVAT: res.renterVAT ?? null,
  renterCountryId: res.renterCountryId ?? null,
  note: res.note ?? null,
  internalNote: res.internalNote ?? null,
  currencyId: res.currencyId ?? null,
  exchangeRate: res.exchangeRate ?? null,
  languageId: res.languageId ?? null,
  fiscalizationRequired: res.fiscalizationRequired ?? false,
  fiscalizationVersion: res.fiscalizationVersion ?? null,
  fiscalizationStatus: res.fiscalizationStatus ?? null,
  fiscalizationJIR: res.fiscalizationJIR ?? null,
  fiscalizationZKI: res.fiscalizationZKI ?? null,
  fiscalizationErrorMessage: res.fiscalizationErrorMessage ?? null,
  providerExternalId: res.providerExternalId ?? null,
});

export const transformFleetVehicleInvoiceRentEditForm = (
  res: InvoiceRent
): InvoiceRentEditFormValues => ({
  id: res.id,
  invoiceNumber: res.invoiceNumber ?? null,
  invoiceOutgoingTypeId: res.invoiceOutgoingTypeId ?? null,
  contractRentId: res.contractRentId ?? null,
  invoiceStatusId: res.status?.id ?? null,
  vehicleId: res.vehicle?.id ?? null,
  contactClientId: res.contactClient?.id ?? null,
  invoiceDate: res.invoiceDate,
  dueDate: res.dueDate,
  durationDays: res.durationDays,
  taxRate: res.taxRate,
  taxTypeId: res.taxTypeId ?? null,
  taxExemptionReasonId: res.taxExemptionReasonId ?? null,
  items: res.items,
  paymentMethodId: res.paymentMethodId ?? null,
  paymentIBAN: res.paymentIBAN ?? null,
  deliveryDate: res.deliveryDate ?? null,
  renterName: res.renterName ?? null,
  renterAddress: res.renterAddress ?? null,
  renterOIB: res.renterOIB ?? null,
  renterVAT: res.renterVAT ?? null,
  renterCountryId: res.renterCountryId ?? null,
  note: res.note ?? null,
  internalNote: res.internalNote ?? null,
  currencyId: res.currencyId ?? null,
  exchangeRate: res.exchangeRate ?? null,
  languageId: res.languageId ?? null,
  fiscalizationRequired: res.fiscalizationRequired ?? false,
  fiscalizationVersion: res.fiscalizationVersion ?? null,
  fiscalizationStatus: res.fiscalizationStatus ?? null,
  fiscalizationJIR: res.fiscalizationJIR ?? null,
  fiscalizationZKI: res.fiscalizationZKI ?? null,
  fiscalizationErrorMessage: res.fiscalizationErrorMessage ?? null,
  providerExternalId: res.providerExternalId ?? null,
});

export const transformFleetVehicleInvoiceRentOnCreate = (
  formValues: InvoiceRentEditFormValues
): any => ({
  invoiceNumber: formValues.invoiceNumber,
  invoiceOutgoingTypeId: formValues.invoiceOutgoingTypeId,
  contractRentId: formValues.contractRentId,
  invoiceStatusId: formValues.invoiceStatusId,
  contactClientId: formValues.contactClientId,
  invoiceDate: formValues.invoiceDate,
  dueDate: formValues.dueDate,
  durationDays: formValues.durationDays,
  taxRate: formValues.taxRate,
  taxTypeId: formValues.taxTypeId,
  taxExemptionReasonId: formValues.taxExemptionReasonId,
  items: formValues.items,
  paymentMethodId: formValues.paymentMethodId,
  paymentIBAN: formValues.paymentIBAN,
  deliveryDate: formValues.deliveryDate,
  renterName: formValues.renterName,
  renterAddress: formValues.renterAddress,
  renterOIB: formValues.renterOIB,
  renterVAT: formValues.renterVAT,
  renterCountryId: formValues.renterCountryId,
  note: formValues.note,
  internalNote: formValues.internalNote,
  currencyId: formValues.currencyId,
  exchangeRate: formValues.exchangeRate,
  languageId: formValues.languageId,
});

export const transformFleetVehicleInvoiceRentOnUpdate = (
  invoiceId: string,
  formValues: InvoiceRentEditFormValues,
): any => ({
  id: invoiceId,
  invoiceOutgoingTypeId: formValues.invoiceOutgoingTypeId,
  contractRentId: formValues.contractRentId,
  invoiceStatusId: formValues.invoiceStatusId,
  vehicleId: formValues.vehicleId,
  contactClientId: formValues.contactClientId,
  invoiceDate: formValues.invoiceDate,
  dueDate: formValues.dueDate,
  durationDays: formValues.durationDays,
  taxRate: formValues.taxRate,
  taxTypeId: formValues.taxTypeId,
  taxExemptionReasonId: formValues.taxExemptionReasonId,
  items: formValues.items,
  paymentMethodId: formValues.paymentMethodId,
  paymentIBAN: formValues.paymentIBAN,
  deliveryDate: formValues.deliveryDate,
  renterName: formValues.renterName,
  renterAddress: formValues.renterAddress,
  renterOIB: formValues.renterOIB,
  renterVAT: formValues.renterVAT,
  renterCountryId: formValues.renterCountryId,
  note: formValues.note,
  internalNote: formValues.internalNote,
  currencyId: formValues.currencyId,
  exchangeRate: formValues.exchangeRate,
  languageId: formValues.languageId,
});

/**
 * Stavka koju poslužitelj vraća za popunjavanje novog računa (prijenos s ugovora).
 * Dobiva novi lokalni id jer je to nova stavka računa, a ne postojeći redak.
 */
export const transformInvoicePrefillItemRow = (res: any): InvoiceOutgoingItemRow => ({
  id: crypto.randomUUID(),
  code: res.code ?? null,
  name: res.name ?? null,
  taxRate: res.taxRate ?? null,
  quantity: res.quantity ?? null,
  priceWithoutTax: res.priceWithoutTax ?? null,
  priceWithTax: res.priceWithTax ?? null,
  discountAmount: res.discountAmount ?? null,
  discountTypeId: res.discountTypeId ?? null,
  total: res.total ?? null,
  deleted: false,
  kpdCode: res.kpdCode ?? null,
  unitOfMeasureId: res.unitOfMeasureId ?? null,
  discountPercent: null,
  billingItemTypeId: res.billingItemTypeId ?? null,
  billingItemTypeName: res.billingItemTypeName ?? null,
  note: res.note ?? null,
  childRows: res.note ? [{ note: res.note }] : [],
});
